import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=4989a6b8&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=4989a6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989a6b8",
  null
  
)

export default component.exports